<template>
  <div>
    <div class="thong-tin-can">
      <div class="item has-text-weight-bold" :class="data.can.class">{{ data.thapthan }}</div>
      <div class="item">
        {{ data.truongsinh }} <br/>
        <span v-if="data.truongSinhDong"></span>
      </div>
      <div class="item">{{ data.can.amduong }}</div>
      <div class="item">{{ data.can.nguhanh }}</div>
    </div>
    <p :class="data.can.class" class="mb-0">{{ data.can.name }}</p>
    <div :class="data.can.class" style="font-size: 15px">({{data.can.dovuong}})</div>
  </div>
</template>

<script>
export default {
  name: 'ItemCan',
  props: {
    data: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
</style>
